module.exports = __webpack_public_path__ + "img/travel_1.1254adc8.png";